import { useState } from "react";

export const useDebounce = () => {
  const [timeoutReference, setTimeoutReference] = useState(null);

  return (callback, timeout) => {
    if (timeoutReference) {
      clearTimeout(timeoutReference);
      setTimeoutReference(null);
    }

    setTimeoutReference(
      setTimeout(() => {
        callback();
      }, timeout)
    );
  };
};
